import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

/**
 * WelcomeMessage Component
 *
 * Displays simple welcome message in the body of the home page.
 * User identity information is displayed in the RDHeader identity bar above.
 *
 * @param {Object} props
 * @param {Object} props.user - User object from context (for reference, not displayed here)
 * @param {Object} props.config - Home page configuration
 */
function WelcomeMessage({ user = null, config }) {
  return (
    <MDBox px={3}>
      <Card sx={{ p: 3 }}>
        {/* Welcome Title */}
        <MDTypography variant="h4" fontWeight="bold" gutterBottom>
          {config.welcomeMessage}
        </MDTypography>

        {/* Subtitle */}
        <MDTypography variant="h6" color="text" fontWeight="regular" mb={3}>
          {config.subtitle}
        </MDTypography>

        {/* Body Message */}
        <MDTypography variant="body1" color="text" mb={2}>
          {config.bodyMessage}
        </MDTypography>

        {/* Future Phase Note */}
        {config.futurePhaseNote && (
          <Box mt={2} pt={2} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
            <MDTypography variant="caption" color="text" fontStyle="italic">
              {config.futurePhaseNote}
            </MDTypography>
          </Box>
        )}
      </Card>
    </MDBox>
  );
}

WelcomeMessage.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    userName: PropTypes.string,
    client: PropTypes.string,
    role: PropTypes.string,
  }),
  config: PropTypes.shape({
    welcomeMessage: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    bodyMessage: PropTypes.string,
    futurePhaseNote: PropTypes.string,
  }).isRequired,
};

export default React.memo(WelcomeMessage);
